import { ProductsActionTypes } from './products-actions';
import { ProductsReducerProps } from './products';

export const initialState: ProductsReducerProps = {
  productList: [],
  productPagination: {
    perPage: 0,
    lastPage: 0,
    total: 0,
    currentPage: 0,
    page: 1,
  },
  productFilter: {
    brand: '',
    category: [],
    title: '',
  },
  sort: 'most_visited',
  isLoading: false,
  csr: false,
};

function productsReducer(state = initialState, action: any) {
  switch (action.type) {
    case ProductsActionTypes.GET_PRODUCT_LIST: {
      return {
        ...state,
        isLoading: true,
        csr: true,
        productPagination: {
          ...state.productPagination,
          page: action?.data?.pagination?.page || state.productPagination.page,
        },
        productFilter: {
          category: action?.data?.productFilter?.category,
          brand: action?.data?.productFilter?.brand,
          title: action?.data?.productFilter?.title,
        },
        sort: action?.data?.sort || state?.sort,
      };
    }

    case ProductsActionTypes.SET_PRODUCT_LIST: {
      return {
        ...state,
        productList: action?.data?.productList,
        productPagination: {
          ...state.productPagination,
          total: action?.data?.pagination?.total,
          lastPage: action?.data?.pagination?.lastPage,
          perPage: action?.data?.pagination?.perPage,
          currentPage: action?.data?.pagination?.currentPage,
        },
        isLoading: false,
      };
    }

    default:
      return state;
  }
}

export default productsReducer;
